
import * as d3 from 'd3'

export default {
  methods: {

    draw_Layout() {

      this.canvasLayout = this.canvasForms
      .append('g')
      .attr('transform', `translate(0,0)`)

      if(this.current.SVG != 'LQ') {
        this.gmx_btn_Navigation(
          this.canvasLayout, 
          {type: 'home', x: 450, y: 97, scale: 0.8,}, 
          {
            remove: [this.canvasLayout, this.canvasLayout],
            dur: 300, 
            timeout: 500,
            exeFunc: this.call_Overall,
            data: null
          }
        )
      }


      // Load a Legend SVG
      this.loadSvg(
        this.canvasLayout, {
        x: 0, y: 0,
        url : this.HOST + `/Visualization/Layout_LQ/${this.current.SVG}.svg`
      }).then(() => { 

        d3.selectAll('text').style('font-family', 'roboto')

        if(this.current.SVG == 'LQ') {
          this.layout.forEach(d=> {

            d3.select(`#COV-${d.SVG}`).transition().duration(150).style('opacity', 0)
            d3.select(`#MASK-${d.SVG}`).style('opacity', 0).style('cursor', 'pointer')
            .on('mouseover', () => {
              d3.select(`#COV-${d.SVG}`).transition().duration(50).style('opacity', .5)
            })
            .on('mouseout', () => {
              d3.select(`#COV-${d.SVG}`).transition().duration(150).style('opacity', 0)
            })
            .on('click', () => {
              this.current.SVG = d.SVG
              this.call_Layout()
            }) 

          })
        }

      }) 

    
    },

  }
}